module.exports = __webpack_public_path__ + "img/damageOverviewContainer.d047e1ef.png";